/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { routerActions } from 'react-router-redux';
import {
  Panel,
  Table,
} from 'react-bootstrap';
import differenceInSeconds from 'date-fns/difference_in_seconds';
import DetailEye from 'loracoms/DetailEye';
import Refresher from 'loracoms/Refresher';
import CollapseToggle from 'loracoms/CollapseToggle';
import DataDirSwitch from 'loracoms/DataDirSwitch';
import RichLabel from 'loracoms/RichLabel';
import PanelToolbar from 'loracoms/PanelToolbar';
import Link from 'loracoms/Link';
import { compactFormat } from 'lorautils/DateTimeUtils';
import IntlMsg from 'lorautils/intl/IntlMsg';
import {
  normalizeAppEUI,
  normalizeMac,
} from 'lorautils/IdUtils';
import deviceActions from 'loraactions/device';
import styles from './styles.scss';

function isNew(time) {
  return differenceInSeconds(new Date(), time) < 10;
}

const propTypes = {
  appId: React.PropTypes.string.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  pushState: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
  getDeviceData: React.PropTypes.func.isRequired,
  deviceData: React.PropTypes.object.isRequired,
};

class DeviceBriefData extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      deviceData: props.deviceData,
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.detailview');
    this.loadData = this.loadData.bind(this);
    this.handleChangeDataDir = this.handleChangeDataDir.bind(this);
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillReceiveProps(nextProps) {
    const { deviceData } = nextProps;
    if (deviceData !== this.props.deviceData) {
      this.setState({ deviceData });
      if (deviceData.status === 'success') {
        this.setState({ dataList: deviceData.data.list });
      }
    }
  }

  loadData() {
    const { deviceId, getDeviceData } = this.props;
    const { dataDir } = this.state;
    getDeviceData(deviceId, { dir: dataDir, limit: 20 });
  }

  handleChangeDataDir(dir) {
    if (this.state.dataDir === dir) {
      return;
    }
    this.setState({ dataDir: dir });
    const { getDeviceData, deviceId } = this.props;
    getDeviceData(deviceId, { dir, limit: 20 });
  }

  render() {
    const { appId, deviceId, pushState } = this.props;
    const { deviceData, dataList = [], expanded = true } = this.state;

    const header = (
      <div>
        {this.intlMsg.msg('latestdata.header')}
        <ul className="icontools">
          <li>
            <DetailEye onClick={() => pushState(`/application/${appId}/devices/${deviceId}/datatool`)} />
          </li>
          <li>
            <Refresher
              onReload={this.loadData}
              reloading={deviceData.status === 'pending'}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={expanded}
              onChange={v => this.setState({ expanded: v })}
            />
          </li>
        </ul>
      </div>
    );

    const dataDirSwitch = <DataDirSwitch onChange={this.handleChangeDataDir} />;

    const rows = dataList.map(d => (
      <tr key={`${d.$time}-${d.gateway}-${d.fcnt}`} className={isNew(d.$time) ? styles.new : ''}>
        <td>{compactFormat(d.$time)}</td>
        <td >
          <Link to={`/application/${(d.appeui).split('-').join('').toLocaleLowerCase()}`}>
            {normalizeAppEUI(d.appeui)}
          </Link>
        </td>
        <td>
          <Link to={`/gateway/detail/${(d.gateway).split('-').join('').toLocaleLowerCase()}`}>
            {normalizeMac(d.gateway)}
          </Link>
        </td>
        <td>
          <Link to={`/gateway/detail/${(d.gateway).split('-').join('').toLocaleLowerCase()}`}>
            {d.name}
          </Link>
        </td>
        <td>
          <RichLabel
            content={d.mtype}
            translateMap={{
              UnconfirmedDataUp: this.intlMsg.msg('unconfirmeddataup'),
              UnconfirmedDataDown: this.intlMsg.msg('unconfirmeddatadown'),
              ConfirmedDataUp: this.intlMsg.msg('confirmeddataup'),
              ConfirmedDataDown: this.intlMsg.msg('confirmeddatadown'),
              JoinRequest: this.intlMsg.msg('joinrequest'),
              JoinAccept: this.intlMsg.msg('joinaccept'),
              RFU: this.intlMsg.msg('rfu'),
              Proprietary: this.intlMsg.msg('proprietary'),
            }}
          />
        </td>
        <td>{d.fcnt}</td>
      </tr>
    ));

    return (
      <Panel bsStyle="aisz-white" header={header} collapsible expanded={expanded}>
        <div>
          <PanelToolbar tools={[dataDirSwitch]} />
          <Table
            className={`aisz-table-light ${styles.dataTable}`}
            striped
            hover
            bordered
            responsive
          >
            <thead>
              <tr>
                <th> { this.intlMsg.msg('data.field.time', 'lora') } </th>
                <th> AppEUI </th>
                <th> { this.intlMsg.msg('data.field.gateway', 'lora') } </th>
                <th> { this.intlMsg.msg('data.field.gwname', 'lora') } </th>
                <th> { this.intlMsg.msg('data.field.msgtype', 'lora')} </th>
                <th> { this.intlMsg.msg('data.field.frameno', 'lora')} </th>
              </tr>
            </thead>
            <tbody>
              {rows}
            </tbody>
          </Table>
        </div>
      </Panel>
    );
  }
}

DeviceBriefData.propTypes = propTypes;

const mapStateToProps = state => ({
  deviceData: state.device.getDeviceData || {},
});

const mapDispatchToProps = {
  getDeviceData: deviceActions.getDeviceData,
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DeviceBriefData));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DeviceBriefData/index.jsx